module.exports = __webpack_public_path__ + "img/LivePlus_W_SM.3bd7f146.png";